import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./css/blogpost.css";

function BlogPosts() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch("https://ghada-m2cb.onrender.com/api/posts");

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setPosts(data);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPosts();
  }, []);

  
  if (posts.length === 0) {
    return <p>جاري التحميل</p>;
  }

  const [latestPost, ...otherPosts] = posts;
  const smallPosts = otherPosts.slice(0, 2);
  const remainingPosts = otherPosts.slice(2);

  return (
    <div className="blog-posts-layout">
      <div className="header-posts">
        <div className="large-featured-post">
          <Link to={`/post/${latestPost._id}`}>
            <img src={latestPost.image} alt="Latest Blog Post" />
            <div className="post-overlay">
              <h2>{latestPost.title}</h2>
              <p>{latestPost.date}</p>
            </div>
          </Link>
        </div>
        <div className="small-featured-posts">
          {smallPosts.map((post) => (
            <div key={post._id} className="small-post">
              <Link to={`/post/${post._id}`}>
                <img src={post.image} alt="Small Blog Post" />
                <div className="post-overlay">
                  <h3>{post.title}</h3>
                  <p>{post.date}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Aside Section with Scrollable Blog Feed */}
      <div className="blog-feed-layout">
        <aside className="sidebar">
          <h2>المدونات</h2>
          <div className="scrollable-feed">
            {remainingPosts.map((post) => (
              <div key={post._id} className="blog-post-sidebar">
                <Link to={`/post/${post._id}`}>
                  <h3>{post.title}</h3>
                  <p>{post.date}</p>
                </Link>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}

export default BlogPosts;
